import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VAppBar,{attrs:{"app":"","fixed":"","dark":"","color":"rojo"}},[_c(VImg,{staticClass:"shrink",attrs:{"alt":"Instituto de los Mexicanos en el Exterior","contain":"","width":"100","src":`${_vm.logoIme}`,"lazy-src":`${_vm.logoIme}`}}),_c('h1',{staticClass:"ml-6 dorado-text text-h6 text--uppercase font-weight-bold"},[_vm._v(" Concursos ")]),_c(VSpacer),_c(VBtn,{attrs:{"dark":"","rounded":"","color":"dorado","href":"/vinculacion/concursos/altares/"}},[_c(VIcon,{attrs:{"left":""}},[_vm._v("mdi-home")]),_vm._v(" Reto de altares ")],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }